module.exports = __webpack_public_path__ + "img/LT112046768.c6dc21b1.png";